import React from 'react';
import {useIntl} from 'react-intl';

import classnames from 'classnames';

import {Badge} from './badge';

import styles from './styles.module.css';

type Props = {
    className?: string;
    show?: boolean;
};

export const OutOfChannelBadge = ({className, show}: Props) => {
    const {formatMessage} = useIntl();

    const message = formatMessage({
        id: 'post_info.out_of_channel',
        defaultMessage: 'Not in current channel',
    });

    return (
        <Badge className={classnames(styles.outOfChannelBadge, className)} show={show}>
            {message}
        </Badge>
    );
};
